<!-- 通过的分页组件 -->
<template>
    <el-row
      style="margin-top: 40px"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <el-col :span="6" style="text-align: left">
        <span class="el-pagination__total">共 {{ total }} 条数据</span>
      </el-col>
      <el-col :span="18" style="text-align: right">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :total="total"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          :current-page="currentPage"
          @size-change="onSizeChange"
          @current-change="onPageChange"
        />
      </el-col>
    </el-row>
  </template>
  
  <script>
  export default {
    name: "PaginationBar",
    props: {
      total: {
        type: Number,
        required: true,
      },
      pageSize: {
        type: Number,
        required: true,
      },
      currentPage: {
        type: Number,
        required: true,
      },
      pageSizes: {
        type: Array,
        default: () => [10],
      },
    },
    emits: ["update:pageSize", "update:currentPage", "page-change"],
    methods: {
      onSizeChange(size) {
        this.$emit("update:pageSize", size);
        this.$emit("update:currentPage", 1); // 重置页码
        this.$emit("page-change");
      },
      onPageChange(page) {
        this.$emit("update:currentPage", page);
        this.$emit("page-change", page);
      },
    },
    mounted() {
      console.log('pageSize',this.pageSize )
    },
  };
  </script>
  